require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-los-angeles-residence.json") })
        }
      }, "path---project-los-angeles-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-los-angeles-residence!./.cache/json/project-los-angeles-residence.json
// module id = 572
// module chunks = 231608221292675